<template>
  <div class="md-layout">
    <!-- 折线图-数据变化 -->
    <template>
      <!-- 标题 -->
      <label class="md-layout-item md-size-30 md-xsmall-size-100" :style="{'padding': '0 12px 0 30px','line-height':'63px'}">
        <span :style="{'font-size': '16px', 'font-weight':'bold'}">{{$I18n("dev_flow")}}</span>
      </label>
      <!-- 类型选择 [新增用户/活跃用户/累计用户] -->
      <div class="md-layout-item md-size-100 title"  :style="{'padding': '0 12px 0 30px','margin-top':'0px','margin-bottom':'20px'}">
        <div @click="line_type = 'create'" class="change" :class="{'selected_change': line_type=='create'}">{{$I18n("new_people")}}</div>
        <!-- <div @click="line_type = 'update'" class="change" :class="{'selected_change': line_type=='update'}">{{$I18n("log_people")}}</div> -->
        <div @click="line_type = 'total'" class="change" :class="{'selected_change': line_type=='total'}">{{$I18n("total_people")}}</div>
      </div>
      <!-- 折线图图表 -->
      <chart-el :options="lineChartsData" class="md-layout-item md-size-100" :style="chartsStyle"></chart-el>
    </template>
  </div>
</template>
<script>
// import * as echarts from "echarts";
import { nDaysAgo, /*timestampToString1000*/ } from "@/common/tools.js";
import {getLine} from "@/pages/Dashboard/ChartsOptions/lineOptions.js";
import ChartEl from "@/pages/Dashboard/ChartsOptions/ChartEl.vue";

export default {
  props: {
    app_id : {
      type: Number,
      default: 0,
    },
  },
  components: {
    ChartEl,
  },
  data() {
    return {
      // lineChartsData: {},
      chartsStyle : { // 用来调整 图表的 样式 的
        height : 'calc(100vh - 470px)',
        width: "100%",
      },
      line_type  : "create", // 折线图-显示的数据类型 {create: 新增用户, update:活跃用户, total:累计用户}
      initData: [],


      line_date  : [         // 折线图-获取的数据的日期范围
        nDaysAgo(7), 
        nDaysAgo(1)
      ], 
    }
  },
  created (){},
  mounted: function(){
    // 数据获取
    this.apiGetData();
  },
  methods:{
    apiGetData(){
      this.$api.getUserAna({
        app_master_id: this.app_id,
        gmt_start: new Date(this.line_date[0]).getTime()/1000,
        gmt_end: new Date(this.line_date[1]).getTime()/1000,
      })
      .then(res => {
        this.initData = res.data;
      })
      .catch(this.$Catch(this.$I18n("get_error"),() => {
        this.initData = [];
      }))
    },
    setTimeToZero(timeStr){ // 将时间戳(YY-mm-DDThh:MM:ss)固定为0点0分0秒后 获取时间戳
      if(!timeStr){
        return 0
      }
      return new Date(timeStr.split("T")[0] + " 00:00:00").getTime()
    },
  },
  watch:{
  },
  computed:{
    lineChartsData(){
      var keyName = "";
      if(this.line_type === "create"){
        keyName = "reg_count";
      } else if(this.line_type === "total"){
        keyName = "total_count";
      }
      const week = [7,6,5,4,3,2,1].map(i => nDaysAgo(i)); // 6天前到今日
      const w_day = week.map(i => i.slice(5)); // 6日到今日(MM-DD)
      const w_ts = week.map(i => new Date(i + " 00:00:00").getTime()) // yyyy-mm-dd 00:00:00

      var a_list = w_day.map(() => 0);
      var i_list = w_day.map(() => 0);
      this.initData.forEach(data => {
        const index = w_ts.indexOf(this.setTimeToZero(data.created_at));
        if(index > -1){
          if(data.app_type == 2){ // IOS
             i_list[index] = data[keyName];
          } else if(data.app_type == 3){ // 安卓
             a_list[index] = data[keyName];
          }
        }
      });
      return getLine(
        w_day,
        [
          {
            name: this.$I18n("android"),
            color:"#FFA06C",
            data: a_list, 
          },{
            name: this.$I18n("ios"),
            color:"#66FFFF",
            data: i_list, 
          },
        ]
      );
    },
  },
}
</script>